import {
  USERLIST_FAILURE,
  USERLIST_REQUEST,
  USERLIST_RESET,
  USERLIST_SUCCESS,
} from './UserListContainer.constants';

export const userlistAction = {
  request: data => ({
    type: USERLIST_REQUEST,
    data,
  }),
  success: data => ({
    type: USERLIST_SUCCESS,
    data,
  }),
  failure: error => ({
    type: USERLIST_FAILURE,
    error,
  }),
  reset: () => ({
    type: USERLIST_RESET,
  }),
};
